import { Box } from "grommet";
import React from "react";
import { useTitle } from "react-use";
// import * as r from "../../routes";
import "./Accounts.scss";

interface AccountsProps {}

const Accounts: React.FC<AccountsProps> = () => {
  useTitle("Accounts | Due");
  // const dispatch = useDispatch();
  // const { accounts, loading } = useAccounts();

  return (
    <Box
      align="start"
      direction="row"
      width="1150px"
      gap="medium"
      pad={{ top: "small" }}
    >

    </Box>
  );
};

export default Accounts;
